<template>
  <div class="user-management-container">
    <el-card>
      <div slot="header" class="card-header">
        <h3>用户管理</h3>
        <div class="header-actions">
          <!--          <el-button-->
          <!--              icon="el-icon-refresh"-->
          <!--              circle-->
          <!--              @click="handleRefresh"-->
          <!--              :loading="loading"-->
          <!--              title="刷新"-->
          <!--          ></el-button>-->
        </div>
      </div>

      <div class="toolbar">
        <!-- 修改这里：将新增用户和刷新按钮包装在一个容器中 -->
        <div class="button-group">
          <el-button type="primary" @click="handleAdd" class="add-btn">新增用户</el-button>
          <el-button
              icon="el-icon-refresh"
              @click="handleRefresh"
              :loading="loading"
              class="refresh-btn"
          >刷新</el-button>
        </div>
        <el-input
            v-model="searchKeyword"
            placeholder="搜索用户名、姓名或手机号"
            @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </div>


      <!-- 桌面端表格视图 -->
      <el-table
          :data="sortedUsers"
          v-loading="loading"
          v-if="!isMobile"
          :default-sort="{prop: 'createTime', order: 'descending'}"
          @sort-change="handleSortChange"
      >
        <el-table-column
            prop="username"
            label="用户名"
            width="120"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
        ></el-table-column>
        <el-table-column
            prop="realName"
            label="姓名"
            width="120"
            :sort-orders="['ascending', 'descending']"
        ></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column
            prop="role"
            label="角色"
            width="100"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <el-tag :type="getRoleType(scope.row.role)">
              {{ getRoleText(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            label="状态"
            width="100"
            sortable="custom"
            :sort-orders="['ascending', 'descending']"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'danger'">
              {{ scope.row.status === 'ACTIVE' ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="180">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
                type="text"
                @click="handleToggleStatus(scope.row)"
                :style="{color: scope.row.status === 'ACTIVE' ? '#F56C6C' : '#67C23A'}"
            >
              {{ scope.row.status === 'ACTIVE' ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" @click="handleResetPassword(scope.row)">重置密码</el-button>
            <el-button
                v-if="!isAdminUser(scope.row)"
                type="text"
                style="color: #F56C6C;"
                @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 移动端卡片视图 -->
      <div v-if="isMobile" class="mobile-user-list" v-loading="loading">
        <!-- 移动端排序控件 -->
        <div class="mobile-sort-controls">
          <el-select
              v-model="mobileSortField"
              placeholder="选择排序字段"
              size="small"
              @change="handleMobileSortChange"
          >
            <el-option label="用户名" value="username"></el-option>
            <!--            <el-option label="姓名" value="realName"></el-option>-->
            <el-option label="角色" value="role"></el-option>
            <el-option label="状态" value="status"></el-option>
            <el-option label="注册时间" value="createTime"></el-option>
          </el-select>
          <el-radio-group v-model="mobileSortOrder" size="small" @change="handleMobileSortChange">
            <el-radio-button label="asc">升序</el-radio-button>
            <el-radio-button label="desc">降序</el-radio-button>
          </el-radio-group>
        </div>

        <div v-for="user in sortedUsers" :key="user.id" class="user-card">
          <el-card shadow="hover">
            <div class="card-header">
              <div class="user-name-status">
                <h4>{{ user.realName }}</h4>
                <el-tag :type="user.status === 'ACTIVE' ? 'success' : 'danger'" size="mini">
                  {{ user.status === 'ACTIVE' ? '启用' : '禁用' }}
                </el-tag>
              </div>
              <div class="user-role">
                <el-tag :type="getRoleType(user.role)" size="mini">
                  {{ getRoleText(user.role) }}
                </el-tag>
              </div>
            </div>

            <div class="card-content">
              <div class="info-row">
                <span class="label">用户名:</span>
                <span class="value">{{ user.username }}</span>
              </div>

              <div class="info-row">
                <span class="label">手机号:</span>
                <span class="value">{{ user.phone }}</span>
              </div>

              <div class="info-row">
                <span class="label">注册时间:</span>
                <span class="value">{{ formatDateTime(user.createTime) }}</span>
              </div>
            </div>

            <div class="card-actions">
              <el-button type="text" size="small" @click="handleEdit(user)">编辑</el-button>
              <el-button
                  type="text"
                  size="small"
                  @click="handleToggleStatus(user)"
                  :style="{color: user.status === 'ACTIVE' ? '#F56C6C' : '#67C23A'}"
              >
                {{ user.status === 'ACTIVE' ? '禁用' : '启用' }}
              </el-button>
              <el-button type="text" size="small" @click="handleResetPassword(user)">重置密码</el-button>
              <el-button
                  v-if="!isAdminUser(user)"
                  type="text"
                  size="small"
                  style="color: #F56C6C;"
                  @click="handleDelete(user)"
              >
                删除
              </el-button>
            </div>
          </el-card>
        </div>
      </div>

      <!-- 空状态提示 -->
      <div v-if="users.length === 0 && !loading" class="empty-state">
        <el-empty description="暂无用户数据">
          <el-button type="primary" @click="handleAdd">新增用户</el-button>
          <el-button @click="handleRefresh">刷新</el-button>
        </el-empty>
      </div>

      <!-- 标准分页（桌面端和中等移动端使用） -->
      <div class="pagination" v-if="!showSimplePagination && users.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
      </div>

      <!-- 简化分页（超小屏幕移动端使用） -->
      <div class="simple-pagination" v-if="showSimplePagination && users.length > 0">
        <div class="simple-pagination-content">
          <el-button
              :disabled="pagination.current === 1"
              @click="handleCurrentChange(pagination.current - 1)"
              size="small"
              class="pagination-btn"
          >
            上一页
          </el-button>

          <span class="page-info">
            {{ pagination.current }} / {{ Math.ceil(pagination.total / pagination.size) }}
          </span>

          <el-button
              :disabled="pagination.current >= Math.ceil(pagination.total / pagination.size)"
              @click="handleCurrentChange(pagination.current + 1)"
              size="small"
              class="pagination-btn"
          >
            下一页
          </el-button>
        </div>

        <div class="pagination-total">
          共 {{ pagination.total }} 条记录
        </div>
      </div>
    </el-card>

    <!-- 新增/编辑用户对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :fullscreen="isMobile">
      <el-form :model="userForm" ref="userForm" :rules="rules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="userForm.realName"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="userForm.role" placeholder="请选择角色">
            <el-option label="学员" value="student"></el-option>
            <el-option label="教练" value="coach"></el-option>
            <el-option label="管理员" value="admin"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="userForm.status">
            <el-radio label="ACTIVE">启用</el-radio>
            <el-radio label="INACTIVE">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {userAPI} from '@/services/api'

export default {
  name: 'UserManagement',
  data() {
    return {
      loading: false,
      users: [],
      searchKeyword: '',
      dialogVisible: false,
      isEdit: false,
      isMobile: false,
      showSimplePagination: false,
      messagePosition: 'top-right',
      // 排序相关数据
      sortField: 'createTime',
      sortOrder: 'descending',
      // 移动端排序数据
      mobileSortField: 'createTime',
      mobileSortOrder: 'desc',
      userForm: {
        username: '',
        realName: '',
        phone: '',
        role: 'student',
        status: 'ACTIVE'
      },
      rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        realName: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur'}
        ],
        role: [
          {required: true, message: '请选择角色', trigger: 'change'}
        ]
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑用户' : '新增用户'
    },
    // 计算排序后的用户列表
    sortedUsers() {
      if (this.users.length === 0) return []

      let field, order

      // 根据设备类型获取排序参数
      if (this.isMobile) {
        field = this.mobileSortField
        order = this.mobileSortOrder
      } else {
        field = this.sortField
        // 将Element UI的排序值转换为通用排序值
        order = this.sortOrder === 'ascending' ? 'asc' : 'desc'
      }

      return this.sortUsers(field, order)
    }
  },
  async mounted() {
    this.checkIsMobile()
    window.addEventListener('resize', this.checkIsMobile)
    await this.loadUsers()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile)
  },
  methods: {
    checkIsMobile() {
      const width = window.innerWidth
      this.isMobile = width <= 768
      this.showSimplePagination = width <= 480

      if (width <= 480) {
        this.messagePosition = 'top'
      } else if (width <= 768) {
        this.messagePosition = 'top'
      } else {
        this.messagePosition = 'top-right'
      }
    },

    showMessage(options) {
      const config = {
        duration: 3000,
        showClose: true,
        ...options
      }

      if (this.isMobile) {
        config.position = 'top'
        config.duration = 2000
      } else {
        config.position = this.messagePosition
      }

      this.$message(config)
    },

    // 处理表格排序变化
    handleSortChange({ prop, order }) {
      this.sortField = prop
      this.sortOrder = order || 'descending'
    },

    // 处理移动端排序变化
    handleMobileSortChange() {
      // 移动端排序变化时无需额外处理，计算属性会自动更新
    },

    // 排序方法
    sortUsers(field, order) {
      const sorted = [...this.users]

      sorted.sort((a, b) => {
        let aValue, bValue

        // 根据字段获取值
        switch (field) {
          case 'username':
            // 用户名按首字母排序
            aValue = this.getFirstChar(a.username || '')
            bValue = this.getFirstChar(b.username || '')
            break
          case 'realName':
            // 姓名按首字母排序
            aValue = this.getFirstChar(a.realName || '')
            bValue = this.getFirstChar(b.realName || '')
            break
          case 'role':
            // 角色按优先级排序
            aValue = this.getRoleOrder(a.role)
            bValue = this.getRoleOrder(b.role)
            break
          case 'status':
            // 状态排序：启用 > 禁用
            aValue = a.status === 'ACTIVE' ? 1 : 2
            bValue = b.status === 'ACTIVE' ? 1 : 2
            break
          case 'createTime':
            // 注册时间排序
            aValue = new Date(a.createTime)
            bValue = new Date(b.createTime)
            break
          default:
            aValue = a[field]
            bValue = b[field]
        }

        // 处理空值情况
        if (aValue === null || aValue === undefined) aValue = ''
        if (bValue === null || bValue === undefined) bValue = ''

        // 比较逻辑
        let result = 0
        if (aValue < bValue) result = -1
        if (aValue > bValue) result = 1

        // 根据排序方向调整结果
        const isDesc = order === 'desc' || order === 'descending'
        return isDesc ? -result : result
      })

      return sorted
    },

    // 获取字符串首字母（用于用户名和姓名排序）
    getFirstChar(str) {
      if (!str) return ''
      // 获取第一个字符并转换为小写
      const firstChar = str.charAt(0).toLowerCase()
      // 如果是中文字符，转换为拼音首字母
      if (/[\u4e00-\u9fa5]/.test(firstChar)) {
        return this.getPinyinFirstChar(firstChar)
      }
      return firstChar
    },

    // 获取中文字符的拼音首字母
    getPinyinFirstChar(char) {
      // 简单的拼音首字母映射（仅包含常用汉字）
      const pinyinMap = {
        '阿': 'a', '八': 'b', '擦': 'c', '搭': 'd', '鹅': 'e', '发': 'f', '嘎': 'g', '哈': 'h',
        '击': 'j', '喀': 'k', '垃': 'l', '妈': 'm', '拿': 'n', '哦': 'o', '啪': 'p', '七': 'q',
        '然': 'r', '撒': 's', '塌': 't', '挖': 'w', '西': 'x', '压': 'y', '杂': 'z',
        // 可以继续添加更多映射
      }
      return pinyinMap[char] || char
    },

    // 获取角色排序值
    getRoleOrder(role) {
      const roleOrder = {
        'ADMIN': 3,
        'admin': 3,
        'COACH': 2,
        'coach': 2,
        'STUDENT': 1,
        'student': 1
      }
      return roleOrder[role] || 99
    },

    // 修改：只保护管理员用户不被删除
    isAdminUser(user) {
      return user.role === 'ADMIN' || user.role === 'admin';
    },

    // 保留原来的方法，以防其他地方使用
    isCoachUser(user) {
      return user.role === 'COACH' || user.role === 'coach';
    },

    async loadUsers() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.current,
          size: this.pagination.size,
          keyword: this.searchKeyword
        }
        const response = await userAPI.getUsers(params)
        this.users = response.data.records
        this.pagination.total = response.data.total
      } catch (error) {
        this.showMessage({
          message: '加载用户列表失败',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    async handleRefresh() {
      await this.loadUsers()
      this.showMessage({
        message: '用户列表已刷新',
        type: 'success'
      })
    },

    handleAdd() {
      this.isEdit = false
      this.userForm = {
        username: '',
        realName: '',
        phone: '',
        role: 'student',
        status: 'ACTIVE'
      }
      this.dialogVisible = true
    },

    handleEdit(user) {
      this.isEdit = true
      this.userForm = {...user}
      this.dialogVisible = true
    },

    async handleSubmit() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          try {
            const formData = {
              id: this.userForm.id,
              realName: this.userForm.realName,
              phone: this.userForm.phone,
              role: this.userForm.role.toUpperCase(),
              status: this.userForm.status
            };

            if (!this.isEdit) {
              formData.username = this.userForm.username;
              formData.idCard = this.userForm.idCard || '';
              await userAPI.createUser(formData);
              this.showMessage({
                message: '创建成功',
                type: 'success'
              })
            } else {
              await userAPI.updateUser(formData);
              this.showMessage({
                message: '更新成功',
                type: 'success'
              })
            }

            this.dialogVisible = false;
            await this.loadUsers();
          } catch (error) {
            this.showMessage({
              message: error.response?.data?.message || '操作失败',
              type: 'error'
            })
          }
        }
      });
    },

    async handleToggleStatus(user) {
      const action = user.status === 'ACTIVE' ? '禁用' : '启用'
      try {
        await this.$confirm(`确定要${action}用户 ${user.realName} 吗？`, '提示', {
          type: 'warning',
          // 添加移动端适配
          customClass: this.isMobile ? 'mobile-confirm-dialog' : '',
          center: this.isMobile
        })

        await userAPI.toggleUserStatus(user.id)
        this.showMessage({
          message: `${action}成功`,
          type: 'success'
        })
        await this.loadUsers()
      } catch (error) {
        if (error !== 'cancel') {
          this.showMessage({
            message: '操作失败',
            type: 'error'
          })
        }
      }
    },

    async handleResetPassword(user) {
      try {
        await this.$confirm(`确定要重置用户 ${user.realName} 的密码吗？`, '提示', {
          type: 'warning',
          // 添加移动端适配
          customClass: this.isMobile ? 'mobile-confirm-dialog' : '',
          center: this.isMobile
        })

        await userAPI.resetPassword(user.id)
        this.showMessage({
          message: '密码重置成功，新密码已发送到用户手机',
          type: 'success'
        })
      } catch (error) {
        if (error !== 'cancel') {
          this.showMessage({
            message: '操作失败',
            type: 'error'
          })
        }
      }
    },

    async handleDelete(user) {
      // 添加额外检查，防止管理员被删除
      if (this.isAdminUser(user)) {
        this.showMessage({
          message: '管理员用户不能被删除',
          type: 'warning'
        })
        return
      }

      try {
        await this.$confirm(`确定要删除用户 "${user.realName}" 吗？此操作不可恢复！`, '警告', {
          type: 'warning',
          confirmButtonText: '确定删除',
          cancelButtonText: '取消',
          confirmButtonClass: 'el-button--danger',
          // 添加移动端适配
          customClass: this.isMobile ? 'mobile-confirm-dialog' : '',
          center: this.isMobile
        })

        await userAPI.deleteUser(user.id)
        this.showMessage({
          message: '用户删除成功',
          type: 'success'
        })
        await this.loadUsers()
      } catch (error) {
        if (error !== 'cancel') {
          this.showMessage({
            message: '删除失败：' + (error.response?.data?.message || '未知错误'),
            type: 'error'
          })
        }
      }
    },

    handleSearch() {
      this.pagination.current = 1
      this.loadUsers()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.loadUsers()
    },

    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadUsers()
    },

    getRoleType(role) {
      const types = {
        'STUDENT': 'primary',
        'COACH': 'success',
        'ADMIN': 'danger'
      }
      return types[role] || 'info'
    },

    getRoleText(role) {
      const texts = {
        'STUDENT': '学员',
        'COACH': '教练',
        'ADMIN': '管理员'
      }
      return texts[role] || role
    },

    formatDateTime(datetime) {
      return new Date(datetime).toLocaleString()
    }
  }
}
</script>

<style scoped>
.user-management-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}

.header-actions {
  display: flex;
  align-items: center;
}

.toolbar {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 移动端排序控件样式 */
.mobile-sort-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

@media (max-width: 480px) {
  .mobile-sort-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .mobile-sort-controls .el-select,
  .mobile-sort-controls .el-radio-group {
    width: 100%;
  }

  .mobile-sort-controls .el-radio-group {
    display: flex;
    justify-content: space-between;
  }

  .mobile-sort-controls .el-radio-button {
    flex: 1;
  }
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.simple-pagination {
  margin-top: 20px;
  text-align: center;
}

.simple-pagination-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 12px;
}

.page-info {
  color: #606266;
  font-size: 14px;
  font-weight: 500;
  min-width: 60px;
  text-align: center;
}

.pagination-total {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
}

.pagination-btn {
  min-width: 70px;
  padding: 8px 12px;
}

.empty-state {
  padding: 40px 0;
  text-align: center;
}

.mobile-user-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.user-card {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.user-name-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-name-status h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-row .label {
  color: #606266;
  font-size: 14px;
  min-width: 80px;
}

.info-row .value {
  color: #303133;
  font-size: 14px;
  text-align: right;
  flex: 1;
}

.card-actions {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.card-actions .el-button {
  flex: 1;
  min-width: 60px;
  font-size: 12px;
}

@media (max-width: 768px) {
  .user-management-container {
    padding: 8px 4px;
  }

  .el-card {
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .el-card__header {
    padding: 12px 16px;
  }

  .el-card__header h3 {
    font-size: 18px;
    margin: 0;
    font-weight: 600;
  }

  .el-card__body {
    padding: 16px;
  }

  .toolbar {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 16px;
    gap: 12px;
  }

  .toolbar .el-button {
    height: 44px;
    font-size: 16px;
    border-radius: 8px;
  }

  .toolbar .el-input {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .el-input-group__append {
    padding: 0 12px;
  }

  .mobile-user-list {
    gap: 12px;
  }

  .user-card .el-card {
    border-radius: 10px;
    margin-bottom: 0;
  }

  .user-card .el-card__body {
    padding: 16px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .user-name-status {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }

  .user-name-status h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
    line-height: 1.4;
  }

  .user-role {
    flex-shrink: 0;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 16px;
  }

  .info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 20px;
  }

  .info-row .label {
    color: #5e6d82;
    font-size: 14px;
    min-width: 70px;
    flex-shrink: 0;
  }

  .info-row .value {
    color: #1f2d3d;
    font-size: 14px;
    text-align: right;
    flex: 1;
    margin-left: 8px;
    word-break: break-all;
  }

  .card-actions {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
  }

  .card-actions .el-button {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    height: 36px;
    padding: 8px 4px;
    border-radius: 6px;
    margin: 0;
  }

  .card-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }

  .header-actions {
    align-self: flex-end;
  }

  .pagination {
    margin-top: 20px;
    text-align: center;
  }

  .el-pagination {
    justify-content: center;
  }

  .el-pagination__total,
  .el-pagination__jump {
    display: none !important;
  }

  .el-pagination__sizes {
    display: none !important;
  }

  .el-dialog__wrapper {
    padding: 0;
  }

  .el-dialog {
    width: 100% !important;
    height: 100%;
    margin: 0 !important;
    max-height: 100%;
    border-radius: 0;
  }

  .el-dialog__header {
    padding: 16px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-dialog__body {
    padding: 20px 16px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }

  .el-dialog__footer {
    padding: 16px;
    background: #f5f7fa;
    border-top: 1px solid #e4e7ed;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  .el-form-item__label {
    width: 70px !important;
    font-size: 15px;
    padding-right: 12px;
  }

  .el-form-item__content {
    margin-left: 70px !important;
  }

  .el-input,
  .el-select {
    width: 100%;
  }

  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .el-radio {
    margin-right: 0;
  }
}

@media (max-width: 480px) {
  .user-management-container {
    padding: 6px 2px;
  }

  .el-card__body {
    padding: 12px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .user-name-status {
    width: 100%;
  }

  .user-name-status h4 {
    font-size: 17px;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .info-row .value {
    text-align: left;
    margin-left: 0;
    width: 100%;
  }

  .card-actions {
    flex-direction: column;
    gap: 8px;
  }

  .card-actions .el-button {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }

  .card-actions .el-button--text:not(:last-child) {
    color: #409EFF;
  }

  .card-actions .el-button--text:last-child {
    color: #F56C6C;
    order: 999;
  }

  .simple-pagination-content {
    gap: 12px;
  }

  .page-info {
    font-size: 13px;
    min-width: 50px;
  }

  .pagination-btn {
    min-width: 60px;
    padding: 6px 10px;
    font-size: 12px;
  }

  .pagination-total {
    font-size: 11px;
  }
}

@media (max-width: 360px) {
  .simple-pagination-content {
    gap: 8px;
  }

  .page-info {
    font-size: 12px;
    min-width: 45px;
  }

  .pagination-btn {
    min-width: 55px;
    padding: 5px 8px;
    font-size: 11px;
  }
}

@media (max-width: 768px) {
  .el-button:active,
  .el-button:focus {
    transform: scale(0.98);
    transition: transform 0.1s ease;
  }

  .user-card:active {
    transform: scale(0.995);
    transition: transform 0.1s ease;
  }

  .pagination-btn:active {
    transform: scale(0.95);
    transition: transform 0.1s ease;
  }
}

@media (max-width: 768px) {
  .el-loading-mask {
    border-radius: 12px;
  }
}
</style>

<!-- 添加全局样式用于移动端确认对话框 -->
<style>
/* 移动端确认对话框样式 */
.mobile-confirm-dialog {
  width: 90% !important;
  max-width: 320px !important;
  margin: 0 auto !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.mobile-confirm-dialog .el-message-box__header {
  padding: 16px 20px 10px;
}

.mobile-confirm-dialog .el-message-box__title {
  font-size: 18px;
  text-align: center;
  width: 100%;
}

.mobile-confirm-dialog .el-message-box__content {
  padding: 20px;
}

.mobile-confirm-dialog .el-message-box__message {
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
}

.mobile-confirm-dialog .el-message-box__btns {
  padding: 0 20px 20px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.mobile-confirm-dialog .el-message-box__btns .el-button {
  flex: 1;
  min-width: 0;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
}

/* 超小屏幕调整 */
@media (max-width: 360px) {
  .mobile-confirm-dialog {
    width: 95% !important;
    max-width: 280px !important;
  }

  .mobile-confirm-dialog .el-message-box__title {
    font-size: 17px;
  }

  .mobile-confirm-dialog .el-message-box__message {
    font-size: 15px;
  }

  .mobile-confirm-dialog .el-message-box__btns .el-button {
    height: 42px;
    font-size: 15px;
  }
}

/* 表格排序样式优化 */
.el-table .caret-wrapper {
  height: 29px !important;
}

.el-table .sort-caret.ascending {
  top: 2px !important;
}

.el-table .sort-caret.descending {
  bottom: 3px !important;
}

.el-table .ascending .sort-caret.ascending {
  border-bottom-color: #409EFF !important;
}

.el-table .descending .sort-caret.descending {
  border-top-color: #409EFF !important;
}
</style>
